import Profie from './Profile';

export default Profie;
